import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BookOpen } from "@phosphor-icons/react";

export default function TrialEnded() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center px-6 py-12">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto mb-8 w-fit">
          <BookOpen size={40} weight="duotone" className="text-[#B08D57]" />
        </div>
        <h1 className="font-serif text-4xl text-[#2C2A28]">Your free trial has ended</h1>
        <p className="mt-4 leading-relaxed text-[#4A4540]">
          Your 10-day free trial ended and, after the 30-day pause, your
          account, memories and keepsakes have been <strong>permanently
          deleted</strong> as described in our Privacy Policy. You were never charged.
        </p>
        <p className="mt-3 text-[#8A7F76]">
          If you'd like to continue your life journey, simply create a new
          account and get Lifetime Access — keep your memories forever, with no
          subscription and no auto-charges.
        </p>
        <Button
          data-testid="restart-btn"
          onClick={() => navigate("/account")}
          className="mt-8 rounded-full bg-[#B08D57] px-8 py-6 text-[#FDFBF7] hover:-translate-y-0.5 hover:bg-[#C19A6B]"
        >
          Create a new account
        </Button>
        <button
          onClick={() => navigate("/")}
          className="mt-4 block w-full text-sm text-[#8A7F76] hover:text-[#B08D57]"
        >
          Back to home
        </button>
      </div>
    </div>
  );
}
